import { render } from "./SetTemplate.vue?vue&type=template&id=c0df4fbc&scoped=true"
import script from "./SetTemplate.vue?vue&type=script&lang=js"
export * from "./SetTemplate.vue?vue&type=script&lang=js"

import "./SetTemplate.vue?vue&type=style&index=0&id=c0df4fbc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0df4fbc"]])

export default __exports__